import { mockFeatures } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择羞羞漫画
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            千万漫画爱好者的共同选择，用实力重新定义免费漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mockFeatures.map((item, idx) => {
            const iconColors = [
              'bg-primary-100 text-primary-600',
              'bg-accent-100 text-accent-600',
              'bg-secondary-100 text-secondary-600',
              'bg-primary-100 text-primary-600',
            ];
            return (
              <div
                key={idx}
                className="group p-6 md:p-7 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-300"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${iconColors[idx]} text-xl mb-4`}>
                  <i className={item.icon}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}